import { create } from "zustand";
import * as middleware from "zustand/middleware";
import type { subscribeWithSelector } from "zustand/middleware/subscribeWithSelector";
import useAuthStore from "./useAuthStore";

type WithTypedSubscribeWithSelector = typeof subscribeWithSelector;

const withTypedSubscribeWithSelector = (middleware as any)
  .subscribeWithSelector as unknown as WithTypedSubscribeWithSelector;

type State = {
  isFullscreen: boolean;
  shouldSignOut: boolean;
  currentProtocol: "webrtc" | "hls";
  firstTimeEnteringLiveRoom: boolean;
  isIpForbidden: boolean;
  keyboardVisible: boolean;
};
type Action = {
  toggleFullscreen: (toggle: boolean) => void;
  setShouldSignOut: (toggle: boolean) => void;
  setProtocol: (value: "webrtc" | "hls") => void;
  setFirstTimeEnteringLiveRoom: (isFirst: boolean) => void;
};

type LayoutState = State & Action;

const useLayoutStore = create(
  withTypedSubscribeWithSelector<LayoutState>((set) => ({
    isFullscreen: false,
    firstTimeEnteringLiveRoom: true,
    isIpForbidden: false,
    toggleFullscreen: (toggle) => set({ isFullscreen: toggle }),
    currentProtocol: !!useAuthStore.getState().token ? "webrtc" : "hls",
    setProtocol: (value) => set({ currentProtocol: value }),
    setFirstTimeEnteringLiveRoom: (isFirst) => set({ firstTimeEnteringLiveRoom: isFirst }),
    shouldSignOut: false,
    setShouldSignOut: (toggle) => set({ shouldSignOut: toggle }),
    keyboardVisible: false,
  })),
);

export const useIsIpForbidden = () => useLayoutStore((s) => s.isIpForbidden);

export const banUserByIp = () => useLayoutStore.setState({ isIpForbidden: true });

export const unBanUserByIp = () => useLayoutStore.setState({ isIpForbidden: false });

export const setKeyboardVisible = (visible: boolean) => useLayoutStore.setState({ keyboardVisible: visible });

export default useLayoutStore;
